import {translation} from "@2d-front-monorepo/core";
import React, {JSX, memo, ReactNode, useMemo} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {Attachments} from "../Attachments";
import {InstallationByHostData} from "../types/InstallationByHostData";
import {ResidencyResult} from "../types/ResidencyResult";
import {Zones} from "../Zones";
import AttachmentsComponent from "./AttachmentsComponent";
import ExpiredAttachmentsComponent from "./ExpiredAttachmentsComponent";

export interface ResidencyComponentProps {
	residency: ResidencyResult;
	installation: InstallationByHostData;
	filesPrefix: string;
	hideAttachments?: boolean;
	children?: ReactNode;
}

function ResidencyComponent({residency, installation, filesPrefix, hideAttachments, children}: ResidencyComponentProps): JSX.Element {
	const zone = Zones.get(installation, residency.zoneId);
	const address = residency.address;
	const expired = useMemo(() => Attachments.findExpired(residency), [residency]);
	const showAttachments = !(hideAttachments ?? false);

	return (
		<div className="card card--residency">
			<div className="grid padded">
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.residency__street_number)}</dt>
					<dd>{address.streetNumber}</dd>
				</dl>
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.residency__street)}</dt>
					<dd>{address.street}</dd>
				</dl>
				{address.unit?.unit && <dl className="title-desc col-1of4">
                    <dt>{translation(PermitTranslations.residency__unit)}</dt>
                    <dd>{address.unit?.unit}</dd>
                </dl>}
				{residency.suffix && <dl className="title-desc col-1of4">
                    <dt>{translation(PermitTranslations.residency__suffix)}</dt>
                    <dd>{residency.suffix}</dd>
                </dl>}
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.residency__postal_code)}</dt>
					<dd>{address.postalCode}</dd>
				</dl>
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.residency__city)}</dt>
					<dd>{address.city}</dd>
				</dl>
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.residency__state)}</dt>
					<dd>{address.state}</dd>
				</dl>
				{residency.zoneId == null
					? undefined
					: <dl className="title-desc col-1of4">
						<dt>{translation(PermitTranslations.zone)}</dt>
						<dd>{zone.name || zone.id}</dd>
					</dl>
				}

				{showAttachments && <AttachmentsComponent entity={residency} linkPrefix={filesPrefix} className="col-full"/>}
				{showAttachments && <ExpiredAttachmentsComponent attachments={expired} linkPrefix={filesPrefix} className="col-full"/>}
			</div>
			{children}
		</div>
	);
}

const MemoizedResidencyComponent: React.FC<ResidencyComponentProps> = memo(ResidencyComponent);
export default MemoizedResidencyComponent;
